import { ProcessAktivitetIDType } from '../../Types/ProcessModel';
import { rutinInfos } from '../../Features/Delsystem/_Common/Const/RutinInfo';

const model: { [index in ProcessAktivitetIDType]: number | null } = {
  paktSkannaTolkaFaktura: null,
  paktLasaInFakturabuntAnkomstregistrera: null,
  paktSakgranskaMottagningsattesteraFaktura: null,
  paktKonteraFaktura: null,
  paktBeslutsattesteraFaktura: null,
  paktKontrollattesteraFaktura: null,
  paktArkiveraPappersfaktura: null,
  paktArkiveraDigitalFaktura: null,
  paktUppratthallaLeverantorsregister: null,
  paktBokforaLeverantorsskulder: null,
  paktBevakaBetalningsdatum: null,
  paktBetalaFaktura: null,
  paktBokforaBetalningsuppdrag: null,
  paktStammaAvReskontra: null,
  paktUpprattaArbetsgivardeklaration: null,
  paktUpprattaInkomstdeklaration: null,
  paktHanteraMomspliktigVerksamhet: null,
  paktHanteraFrivilligFastighetsmoms: null,
  paktHanteraSkattekonto: null,
  paktBevakaLikvidaMedel: null,
  paktAnalyseraLikviditetsrapport: null,
  paktHanteraKortfristigaPlaceringar: null,
  paktHanteraLangfristigaPlaceringar: null,
  paktHanteraStiftelsemedel: null,
  paktTaFramBokslutsanvisningar: null,
  paktUpprattaManadsrapporterArsbokslut: null,
  paktUpprattaStiftelsebokslut: null,
  paktTextunderlagForvaltningsberattelsen: null,
  paktUpprattaArsredovisning: null,
  paktUpprattaRapporteraStatistikSCB: rutinInfos.rtnAdresser_HarUtgatt.rutinID,
  Definitivbokning: null,
  SkapaUtbetalningsorder: null,
  Betalning: null,
  Aterredovisning: null,
};

export default model;
